<template>
  <div class="mind524-page" :style="pageStyle">
    <div class="game-screen" :style="gameScreenStyle">
      <div class="start-view">
        <div class="start-view-innert">
          <div class="input-form">
            <img
              class="start-img-voiss"
              :src="img.voiss"
              alt=""
              @click="btnLogin"
            />
            <br />
            <div class="form-content">
              <input
                v-model="account"
                class="text-input"
                type="text"
                placeholder="輸入帳號"
              />
              <input
                v-model="pawd"
                class="text-input"
                type="password"
                placeholder="輸入密碼"
              />
              <!-- <div style="text-align:right">
                <button color="#4E4DA8" class="login-btn hover" @click="btnLogin">
                  登入
                </button>
              </div> -->
              <button
                color="#4E4DA8"
                class="start-btn hover"
                @click="btnLogin"
              >
                登入
              </button>
            </div>
          </div>
          <div class="start-view-float-desc">
            <!-- 你即將進入<span style="color:#F2C94C">缺點擊破訓練場</span> -->
            <br />
            <!-- 用聲音互動，體驗他人的真實心聲 -->
            <br />
            <!-- 瞄準思維，洞察學習 -->
          </div>
          <div class="start-view-mute">
            <button
              class="start-view-mute-btn hover"
              @click.stop="btnToggleStartBGM"
            >
              <v-icon size="16" color="#FFFFFF">
                {{ startViewMuteIcon }}
              </v-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'

const axios = Axios.create({
  baseURL: 'https://api.voiss.cc/vapi',
  // baseURL: 'http://localhost:8088/vapi',
  withCredentials: true
})

export default {
  computed: {
    screen () {
      const { height, width } = this.$store.state.screen
      return {
        height: height - 1,
        width
      }
    },
    gameScreenRect () {
      const screen = this.screen
      // const gameHeight = screen.height
      // const w = gameHeight * (375 / 812)
      const w = 414
      // console.log(`'375/812 = ${w}/'${gameHeight}`)
      const gameWidth = screen.width > w ? w : screen.width
      // if (gameWidth > w) {
      //   gameWidth = w
      // }
      const left = screen.width / 2 - gameWidth / 2
      return {
        top: 0,
        left,
        height: screen.height,
        width: gameWidth
      }
    },

    pageStyle () {
      const { height, width } = this.screen
      return {
        height: height + 'px',
        width: width + 'px'
      }
    },
    gameScreenStyle () {
      const { top, left, height, width } = this.gameScreenRect

      return {
        top: `${top}px`,
        left: `${left}px`,
        height: `${height}px`,
        width: `${width}px`,
        backgroundColor: '#F5EEF7'
      }
    }
  },
  data () {
    return {
      img: {
        mascot1: require('@/assets/mind524/img/mascot-1.png'),
        mascot2: require('@/assets/mind524/img/mascot-2.png'),
        play: require('@/assets/mind524/img/play.png'),
        pause: require('@/assets/mind524/img/pause.png'),
        replay: require('@/assets/mind524/img/replay.png'),
        recordPause: require('@/assets/mind524/img/record-pause.png'),
        recordPlay: require('@/assets/mind524/img/record-play.png'),
        jumpBack: require('@/assets/mind524/img/jump-back.png'),
        music: require('@/assets/mind524/img/music.png'),
        voiss: require('@/assets/mind524/img/voiss-start.png'),
        loadding: require('@/assets/mind524/img/loadding.svg')
      },
      color: {
        // 畫面 1 相關
        text0: '#2D234C', // 最上面的標題
        text1_1: '#FCFCFC', // 畫面上面的 content
        text2: '#30234E', // 日期
        text3_1: '#4A3966', // 底下浮動視窗的 content
        highlight0: '#504EA9', // 上面的 title 的部分
        highlight1: '#FF6B6B', // 底下浮動視窗的 content

        // 畫面 2 額外修改
        text1_2: '#202042', // 畫面上面的 content
        text3_2: '#5F5078', // 底下浮動視窗的 content
        text4: '484BA4', // stt 的部分
        edit: '#000', // 編輯時的文字
        save: '#9F97CE' // 存檔鈕
      },
      account: '',
      pawd: ''
    }
  },
  async mounted () {
    await this.getLoginState()
  },
  methods: {
    async btnLogin () {
      try {
        const res = await axios.post('/ng-login', {
          acc: this.account,
          pawd: this.pawd
        })
        if (res.data.success) {
          localStorage.setItem('m524-account', this.account)
          this.$router.push('/mind524')
        } else {
          alert(res.data.message)
        }
      } catch (e) {
        console.error(e)
      }
    },
    async getLoginState () {
      try {
        const res = await axios.get('/ng-user-state', {
          acc: this.account,
          pawd: this.pawd
        })
        if (res.data && res.data.acc) {
          if (confirm('已登入，是否自動前往下一頁?')) {
            setTimeout(() => {
              this.$router.push('/mind524')
            })
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
    delay (t) {
      return new Promise(resolve => {
        setTimeout(resolve, t)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin mini_scroll {
  &::-webkit-scrollbar {
    // position: relative;
    width: 4px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: none;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #aaa2;
  }
  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #fff2;
  }
}
@mixin mini_scroll_2 {
  &::-webkit-scrollbar {
    // position: relative;
    width: 4px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: none;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #aaa4;
  }
  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #fff4;
  }
}
// ----------- 通用 -----------
.pos-abs {
  position: absolute;
}

.hover:hover {
  cursor: pointer;
  opacity: 0.8;
}

.slide-fade-enter-active {
  transition: all 0.6s ease;
}
.slide-fade-leave-active {
  transition: all 0.6s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(100px);
  opacity: 0;
}

// ----------- 頁面區塊相關 -----------
.mind524-page {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #35275a;
  background-image: url('../assets/mind524/img/window-background.png');
  background-size: cover;
  overflow-y: hidden;
  overflow-x: hidden;
}
.game-screen {
  position: absolute;
  $gradient0: #f0f3f6;
  $gradient1: #79afff;
  $gradient2: #86218e;
  $gradient3: #2d1339;
  background: linear-gradient(
    270deg,
    $gradient0 0%,
    $gradient1 33%,
    $gradient2 66%,
    $gradient3 100%
  );
  background: -moz-linear-gradient(
    270deg,
    $gradient0 0%,
    $gradient1 33%,
    $gradient2 66%,
    $gradient3 100%
  );
  background: -webkit-linear-gradient(
    270deg,
    $gradient0 0%,
    $gradient1 33%,
    $gradient2 66%,
    $gradient3 100%
  );
  background: -o-linear-gradient(
    270deg,
    $gradient0 0%,
    $gradient1 33%,
    $gradient2 66%,
    $gradient3 100%
  );
}
.text-wave-bg-wrapper {
  overflow: hidden;
}
.text-wave-bg {
  position: absolute;
  left: 50%;
  overflow-y: hidden;
  overflow-x: hidden;
  border-radius: 37%;
  transform: translateX(-50%);
}
.main-content-area {
  // @include mini_scroll;
  position: absolute;
  box-sizing: border-box;
  overflow: hidden;

  .top-title {
    padding: 42px 42px 0px 42px;
    text-align: center;
  }
  .top-content {
    // background-color: #665AB199;
    background-image: url('../assets/mind524/img/bg-purple.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    margin: 10px 20px 0px 20px;
    padding: calc(8vh) 27px 47px 34px;
    // border-radius: 15px;
    font-size: 16px;

    // box-shadow: 0px 5px 10px #0002;
    // padding-right: 50px;
    .main-content {
      @include mini_scroll;
      height: 90%;
      padding-right: 10px;
      white-space: normal;
      overflow-y: scroll;
      overflow-x: hidden;
    }
  }
  .content-player-outer {
    position: absolute;
  }
}
.bottom-loadding {
  position: absolute;
  box-sizing: border-box;
  color: #fff2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  .bottom-loadding-img-wrapper {
  }
}
.float-area-outer {
  position: absolute;
  box-sizing: border-box;

  // box-shadow: 0px -10px 20px #0002;
  .float-area {
    overflow: hidden;
    background: #f5eef7;
    // border-radius: 20px 20px 0 0;
    // height: 100%;
    padding-top: 20px;
    padding-left: 18px;
    padding-right: 24px;
  }

  .date-area {
    & > div {
      display: flex;
      padding-left: 18px;
      padding-right: 12px;
      justify-content: space-between;
      font-size: 12px;
    }
  }
  .bottom-title-1 {
    & > div {
      @include mini_scroll_2;
      width: 100%;
      height: 100px;
      padding-left: 18px;
      padding-right: 18px;
      white-space: normal;
      overflow-y: scroll;
      overflow-x: hidden;
    }
  }
  .mic-area {
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .pencil-area {
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
.start-view-float-desc {
  position: absolute;
  top: 350px;
  left: 0;
  width: 100%;
  text-align: center;
  line-height: 2.5;
  color: white;
  font-size: 14px;
}
.start-view-mute {
  position: absolute;
  top: 130px;
  left: calc(50% + 40px);
  .start-view-mute-btn {
    background-color: #f2c94c;
    border-radius: 30px;
    height: 30px;
    width: 30px;
  }
}
.start-view {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: #212222;
  .start-img-voiss {
    height: 160px;
  }
  .start-view-innert {
    position: absolute;
    width: 100%;
    top: 17%;
    left: 0;
  }
  .input-form {
    position: absolute;
    left: 0;
    left: 0;
    width: 100%;
    text-align: center;
    .form-content {
      display: inline-block;
      margin-top: 30px;
      padding: 12px;
      padding-top: 0px;
      min-width: 40%;
      width: 150px;
      max-width: 80%;
      background-color: white;
      box-shadow: 0px 5px 10px #0002;
      border-radius: 15px;
      & > * {
        margin-top: 12px;
      }
    }
    .text-input {
      width: 100%;
      background-color: #ccc;
      padding: 4px;
      border-radius: 4px;
      color: black;
      text-align: center;
    }
    .login-btn {
      background-color: #4e4da8;
      padding: 4px;
      padding-right: 8px;
      padding-left: 8px;
      border-radius: 8px;
      font-size: 14px;
      color: white;
    }
    .start-btn {
      width: 100%;
      background-color: #4e4da8;
      padding: 4px;
      border-radius: 8px;
      font-size: 14px;
      color: white;
    }
  }
}
@media screen and (max-height: 600px) {
  .start-view {
    .start-view-innert {
      top: 8%;
    }
  }
}
@media screen and (max-height: 500px) {
  .start-view {
    .start-view-innert {
      top: 0%;
    }
  }
}
</style>
